module.exports = __webpack_public_path__ + "static/media/g7p_pepfold.ad96908e.pdb";


//////////////////
// WEBPACK FOOTER
// ./src/data/g7p_pepfold.pdb
// module id = 194
// module chunks = 0